import { render, staticRenderFns } from "./profile-update.html?vue&type=template&id=09c552b0&"
import script from "./profile-update.js?vue&type=script&lang=js&"
export * from "./profile-update.js?vue&type=script&lang=js&"
import style0 from "./profile-update.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports